import apiClient from '@/api/index'

export default {
  index (fighterId, params) {
    return apiClient.get(`/fighters/${fighterId}/media`, { params })
  },
  store (fighterId, formData) {
    return apiClient.post(`/fighters/${fighterId}/media`, formData)
  },
  show (fighterId, mediaId, params) {
    return apiClient.get(`/fighters/${fighterId}/media/${mediaId}`, { params })
  },
  update (fighterId, mediaId, formData) {
    formData.append('_method', 'PUT')
    return apiClient.post(`/fighters/${fighterId}/media/${mediaId}`, formData)
  },
  destroy (fighterId, mediaId) {
    return apiClient.delete(`/fighters/${fighterId}/media/${mediaId}`)
  }
}
